module.exports = __webpack_public_path__ + "media/mayasto.25978916.mp4";